import React from 'react'
import { useStateValue } from '@State'

export const ReadingLinksContainer = ({
  selectedResourceIds,
  handleCheck,
  selectedTitleIds,
  handleTitleCheck,
}) => {
  const [currentState] = useStateValue()

  return (
    <React.Fragment>
      <div className="d-flex justify-content-between">
        <div>
          {currentState.connectedCourses.map(course => {
            return (
              <div key={`${course.coursenum}-titlepage-key`}>
                <h2>{course.bookTitle}</h2>
                <h3>Title Page Link</h3>
                <div style={{ marginLeft: '1.25rem' }}>
                  <input
                    type="checkbox"
                    id={`titlePageLink-${course.coursenum}-id`}
                    value={`titlepage-${course.coursenum}`}
                    onChange={handleTitleCheck}
                    checked={selectedTitleIds.includes(
                      `titlepage-${course.coursenum}`
                    )}
                  />
                  <label
                    className="ml-2"
                    htmlFor={`titlePageLink-${course.coursenum}-id`}
                  >{`${course.bookTitle} Title Page`}</label>
                </div>
                <h3>Reading Links</h3>
                {course.bookNodes.map((node, idx) => {
                  if (node.isSelectable) {
                    return (
                      <div
                        key={`${course.coursenum}-${idx}`}
                        style={{ marginLeft: `${node.depth * 2}rem` }}
                      >
                        <input
                          type="checkbox"
                          id={node.id}
                          value={node.id}
                          onChange={handleCheck}
                          checked={selectedResourceIds.includes(node.id)}
                        />
                        <label className="ml-2" htmlFor={node.id}>
                          {node.title}
                        </label>
                      </div>
                    )
                  } else {
                    return (
                      <div
                        key={`${course.coursenum}-${idx}`}
                        style={{ marginLeft: `${node.depth}rem` }}
                      >
                        <h4 className={`ml-${2 * node.depth}`}>{node.title}</h4>
                      </div>
                    )
                  }
                })}
              </div>
            )
          })}
        </div>
      </div>
    </React.Fragment>
  )
}
